import { __decorate } from "tslib";
import { attr, customElement, FASTElement, html } from '@microsoft/fast-element';
import { ChameleonElementMixin } from '../common/ChameleonElement';
import { ensureDefaultAttribute } from '../common/utils/Attributes';
import styles from './Skeleton.styles.scss';
const template = html `<template
  :style="${(x) => (x.variant === 'rectangle' ? `width: ${x.computedWidth()};` : ``)}"
></template>`;
export const skeletonDefinition = {
    name: 'chameleon-skeleton',
    template,
    styles,
};
let SkeletonComponent = class SkeletonComponent extends ChameleonElementMixin(FASTElement) {
    constructor() {
        super(...arguments);
        this.width = null;
    }
    computedWidth() {
        var _a;
        const defaultWidth = (_a = this.width) !== null && _a !== void 0 ? _a : '100%';
        return this.width && Number.isInteger(Number(this.width)) ? `${this.width}px` : defaultWidth;
    }
    connectedCallback() {
        super.connectedCallback();
        ensureDefaultAttribute(this, 'variant', 'rectangle');
        ensureDefaultAttribute(this, 'size', 'medium');
    }
};
__decorate([
    attr
], SkeletonComponent.prototype, "variant", void 0);
__decorate([
    attr
], SkeletonComponent.prototype, "size", void 0);
__decorate([
    attr
], SkeletonComponent.prototype, "width", void 0);
SkeletonComponent = __decorate([
    customElement(skeletonDefinition)
], SkeletonComponent);
export { SkeletonComponent };
